import { render, staticRenderFns } from "./cardministration.vue?vue&type=template&id=607fabad&scoped=true"
import script from "./cardministration.vue?vue&type=script&lang=js"
export * from "./cardministration.vue?vue&type=script&lang=js"
import style0 from "./cardministration.vue?vue&type=style&index=0&id=607fabad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fabad",
  null
  
)

export default component.exports